/**
 * Representa os tipos de alvo para aplicação/remoção em lote de seleções configuráveis.
 */
export enum ESelectionApplyTargetType {
  AllProducts,
  SelectedProducts,
  AllCatalogItems,
  SelectedCatalogItems,
  AllCombos,
  SelectedCombos,
}
